import { Component } from 'preact';

import DayPicker, { DateUtils } from 'react-day-picker';
import YearMonthForm from './utils';
import moment from 'moment';

const currentYear = new Date().getFullYear();
const fromMonth = new Date(2000, 0);
const toMonth = new Date();

const enabledStyle = `.DayPicker-Day--enabled {

}`;

export default class SpecificDatePicker extends Component {
    constructor(props) {
        super(props);
    }

    onDayClick(date, modifiers) {
        if (modifiers.disabled) {
            return;
        }
        this.props.onDayClick(date);
    }

    handleResetClick() {
        this.props.onDayClick(undefined);
    }

    enabled = (day) => {
        if (this.props.enabledDays.length == 0) {
            return true;
        } 
        return this.props.enabledDays.includes(day.toString());
    }

    disabled = (day) => {
        return !this.props.enabledDays.includes(day.toString());
    }

    calculateFromMonth = () => {
        if (this.props.enabledDays.length == 0) {
            return fromMonth
        } else {
            return this.props.earliestDate;
        }
    }

    calculateToMonth = () => {
        if (this.props.enabledDays.length == 0) {
            return toMonth
        } else {
            return this.props.latestDate;
        }
    }

    render() {
        let enabled = this.enabled
        let disabled = (this.props.enabledDays.length == 0 ? [{after: new Date()}] : this.disabled);
        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: "center"}}>
                <style>{enabledStyle}</style>
                <DayPicker 
                    selectedDays={this.props.selectedDate}
                    onDayClick={(date, modifiers) => this.onDayClick(date, modifiers)}
                    month={this.props.month}
                    fromMonth={this.calculateFromMonth()}
                    toMonth={this.calculateToMonth()}
                    disabledDays={disabled}
                    modifiers={{enabled}}
                    captionElement={({ date, localeUtils }) => (
                        <YearMonthForm
                            date={date}
                            localeUtils={localeUtils}
                            onChange={(month) => this.props.handleYearMonthChange(month)}
                            fromMonth={this.calculateFromMonth()}
                            toMonth={this.calculateToMonth()}
                            enabledDays={this.props.enabledDays}
                        />
                    )}
                />
                {this.props.selectedDate
                ? moment(this.props.selectedDate).format("dddd, MMMM Do YYYY")
                : 'Please select a day'}
            </div>
            
        )
    }
}


// WEBPACK FOOTER //
// ./components/search/datePickers/specificDatePicker.js